import { Route, Routes } from "react-router-dom";
import { Layout } from "../components/_app/Layout";
import DashboardLayout from "../components/dashboard/_app/DashboardLayout";
import Home from "../pages/Home";
import PricingPage from "../pages/PricingPage";
import ProductItemPage from "../pages/ProductItemPage";
import Productos from "../pages/Productos";
import ProfessionalDetailPage from "../pages/ProfessionalDetailPage";
import Professionals from "../pages/Professionals";
import ProjectDetailPage from "../pages/ProjectDetailPage";
import Projects from "../pages/Projects";
import ViewMagazine from "../pages/ViewMagazine";
import Login from "../pages/auth/Login";
import Register from "../pages/auth/Register";

import AllMagagine from "../pages/dashboard/admin-dashboard/AllMagagine";
import AllProductList from "../pages/dashboard/admin-dashboard/AllProductList";
import AllProjectList from "../pages/dashboard/admin-dashboard/AllProjectList";
import AllSubmissions from "../pages/dashboard/admin-dashboard/AllSubmissions";
import AllTags from "../pages/dashboard/admin-dashboard/AllTags";
import AllUserList from "../pages/dashboard/admin-dashboard/AllUserList";
import ScamReport from "../pages/dashboard/admin-dashboard/ScamReport";
import AdminDiscounts from "../pages/dashboard/admin-dashboard/AdminDiscounts";
import AdminAnalytics from "../pages/dashboard/admin-dashboard/AdminAnalytics";
import AddNewProduct from "../pages/dashboard/user-dashboard/AddNewProduct";
import AddNewProject from "../pages/dashboard/user-dashboard/AddNewProject";
import UserCollaborators from "../pages/dashboard/user-dashboard/UserCollaborators";
import UserMembership from "../pages/dashboard/user-dashboard/UserMembership";
import UserProductList from "../pages/dashboard/user-dashboard/UserProductList";
import UserProfilePage from "../pages/dashboard/user-dashboard/UserProfilePage";
import UserProjectsList from "../pages/dashboard/user-dashboard/UserProjectsList";
import ProductDetailPage from "./../pages/ProductDetailPage";
import UpdateProduct from "../pages/dashboard/user-dashboard/updateData/UpdateProduct";
import Success from "../pages/payment/Success";
import Cancel from "../pages/payment/Cancel";
import Checkout from "../pages/payment/Checkout";

const Router = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route
        path="/"
        element={
          <Layout>
            <Home />
          </Layout>
        }
      />
      <Route
        path="/projects"
        element={
          <Layout>
            <Projects />
          </Layout>
        }
      />
      <Route
        path="/professionals"
        element={
          <Layout>
            <Professionals />
          </Layout>
        }
      />
      <Route
        path="/product-profile"
        element={
          <Layout>
            <Productos />
          </Layout>
        }
      />
      <Route
        path="/products"
        element={
          <Layout>
            <Productos />
          </Layout>
        }
      />
      <Route
        path="/project/:projectId"
        element={
          <Layout>
            <ProjectDetailPage />
          </Layout>
        }
      />
      <Route
        path="/professionals/:UserId"
        element={
          <Layout>
            <ProfessionalDetailPage />
          </Layout>
        }
      />
      <Route
        path="/product-profile/:UserId"
        element={
          <Layout>
            <ProductDetailPage />
          </Layout>
        }
      />
      <Route
        path="/product/:productId"
        element={
          <Layout>
            <ProductItemPage />
          </Layout>
        }
      />

      <Route
        path="/magazines"
        element={
          <Layout>
            <ViewMagazine />
          </Layout>
        }
      />
      <Route
        path="/checkout"
        element={
          <Layout>
            <Checkout />
          </Layout>
        }
      />

      <Route
        path="/payment-success"
        element={
          <Layout>
            <Success />
          </Layout>
        }
      />
      <Route
        path="/payment-cancel"
        element={
          <Layout>
            <Cancel />
          </Layout>
        }
      />

      <Route
        path="/all-users"
        element={
          <DashboardLayout>
            <AllUserList />
          </DashboardLayout>
        }
      />
      <Route
        path="/all-projects"
        element={
          <DashboardLayout>
            <AllProjectList />
          </DashboardLayout>
        }
      />

      <Route
        path="/all-products"
        element={
          <DashboardLayout>
            <AllProductList />
          </DashboardLayout>
        }
      />

      <Route
        path="/scam-report"
        element={
          <DashboardLayout>
            <ScamReport />
          </DashboardLayout>
        }
      />

      <Route
        path="/all-submissions"
        element={
          <DashboardLayout>
            <AllSubmissions />
          </DashboardLayout>
        }
      />

      <Route
        path="/tags"
        element={
          <DashboardLayout>
            <AllTags />
          </DashboardLayout>
        }
      />

      <Route
        path="/magzine"
        element={
          <DashboardLayout>
            <AllMagagine />
          </DashboardLayout>
        }
      />

      <Route
        path="/admin-discounts"
        element={
          <DashboardLayout>
            <AdminDiscounts />
          </DashboardLayout>
        }
      />

      <Route
        path="/admin-analytics"
        element={
          <DashboardLayout>
            <AdminAnalytics />
          </DashboardLayout>
        }
      />

      {/* user dashboard routes*/}

      <Route
        path="/user-profile"
        element={
          <DashboardLayout>
            <UserProfilePage />
          </DashboardLayout>
        }
      />
      <Route
        path="/user-projects"
        element={
          <DashboardLayout>
            <UserProjectsList />
          </DashboardLayout>
        }
      />

      <Route
        path="/user-products"
        element={
          <DashboardLayout>
            <UserProductList />
          </DashboardLayout>
        }
      />

      <Route
        path="/user-collaborators"
        element={
          <DashboardLayout>
            <UserCollaborators />
          </DashboardLayout>
        }
      />

      <Route
        path="/user-membership"
        element={
          <DashboardLayout>
            <UserMembership />
          </DashboardLayout>
        }
      />

      <Route
        path="/add-new-project"
        element={
          <DashboardLayout>
            <AddNewProject />
          </DashboardLayout>
        }
      />

      <Route
        path="/update-product/:productId"
        element={
          <DashboardLayout>
            <UpdateProduct />
          </DashboardLayout>
        }
      />

      <Route
        path="/add-new-product"
        element={
          <DashboardLayout>
            <AddNewProduct />
          </DashboardLayout>
        }
      />
    </Routes>
  );
};

export default Router;
